// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function LotCardTagline$TaglineText(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotCardTagLineText"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label12Medium.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                          tl: {
                            hd: Css.textTransform("uppercase"),
                            tl: {
                              hd: Css.fontSize(Css.px(10)),
                              tl: /* [] */0
                            }
                          }
                        }),
                    children: props.children
                  })
            });
}

var TaglineText = {
  make: LotCardTagline$TaglineText
};

function LotCardTagline$Indicator$Dot(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "LiveIndicator"
                },
                tl: /* [] */0
              },
              children: React.createElement("span", {
                    className: Curry._1(Css.style, {
                          hd: Css.height(Css.px(8)),
                          tl: {
                            hd: Css.width(Css.px(8)),
                            tl: {
                              hd: Css.marginRight(Css.px(4)),
                              tl: {
                                hd: Css.backgroundColor(props.dotColor),
                                tl: {
                                  hd: Css.borderRadius(Css.pct(50)),
                                  tl: {
                                    hd: Css.display("inlineBlock"),
                                    tl: {
                                      hd: Css.alignSelf(Css.center),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        })
                  })
            });
}

var Dot = {
  make: LotCardTagline$Indicator$Dot
};

function LotCardTagline$Indicator$Live(props) {
  return React.createElement(LotCardTagline$Indicator$Dot, {
              dotColor: Css.hex(SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag)
            });
}

var Live = {
  make: LotCardTagline$Indicator$Live
};

var Indicator = {
  Dot: Dot,
  Live: Live
};

var taglineLayout = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: /* [] */0
    });

function LotCardTagline(props) {
  var sold = props.sold;
  var bidPhase = props.bidPhase;
  var userBid = props.userBid;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var wonOrLost;
  if (userBid !== undefined) {
    var match$1 = userBid.bidState;
    wonOrLost = match$1 === "Won" ? "Won" : (
        match$1 === "Lost" ? "Lost" : "NotBidding"
      );
  } else {
    wonOrLost = "NotBidding";
  }
  var soldOrClosed;
  var exit = 0;
  if (sold !== undefined && typeof sold === "object" && sold.NAME === "ResultVisible" && sold.VAL.isSold) {
    soldOrClosed = "Sold";
  } else {
    exit = 1;
  }
  if (exit === 1) {
    soldOrClosed = Caml_obj.equal(bidPhase, "Closed") ? "Closed" : "Hidden";
  }
  if (wonOrLost === "Won") {
    return React.createElement(LotCardTagline$TaglineText, {
                children: Curry._1(t, "LotListContainer_youHaveWonThislot")
              });
  } else if (wonOrLost === "Lost") {
    return React.createElement(LotCardTagline$TaglineText, {
                children: Curry._1(t, "LotListContainer_youHaveLostThislot")
              });
  } else if (Caml_obj.equal(bidPhase, "Live") || Caml_obj.equal(bidPhase, "ConfirmingResult")) {
    return React.createElement("div", {
                className: taglineLayout
              }, React.createElement(LotCardTagline$Indicator$Live, {}), React.createElement(LotCardTagline$TaglineText, {
                    children: Curry._1(t, "Common_live")
                  }));
  } else if (soldOrClosed === "Closed") {
    return React.createElement(LotCardTagline$TaglineText, {
                children: Curry._1(t, "Common_lotClosed")
              });
  } else if (props.isPremium) {
    return React.createElement(LotCardTagline$TaglineText, {
                children: Curry._1(t, "Common_premiumLot")
              });
  } else {
    return null;
  }
}

var make = LotCardTagline;

export {
  TaglineText ,
  Indicator ,
  taglineLayout ,
  make ,
}
/* taglineLayout Not a pure module */
